export default __webpack_public_path__ + "static/media/logo1.d5ea2a08.jpg";